
const fields = {

    pristanak: {
        key: 'pristanak',
        type: 'hCheckbox',
        templateOptions: {
            label: 'Pristanak'
        }
    },

    prezime: {
        key: 'prezime',
        type: 'hInput',
        templateOptions: {
            label: 'Prezime',
            required: true
        }
    },
    ime: {
        key: 'ime',
        type: 'hInput',
        templateOptions: {
            label: 'Ime',
            required: true
        }
    },
    datum_rodjenja: {
        key: 'datum_rodjenja',
        type: 'hDatepicker',
        templateOptions: {
            label: 'Datum rođenja',
            required: true
        }
    },
    datum_pristanka: {
        key: 'datum_pristanka',
        type: 'hDatepicker',
        templateOptions: {
            label: 'Datum pristanka',
            required: true,
        }
    },
    naziv: {
        key: 'naziv',
        type: 'hInput',
        templateOptions: {
            label: 'Naziv operativnog zahvata',
            required: true
        }
    },
    mjesto_rodjenja: {
        key: 'mjesto_rodjenja',
        type: 'hInput',
        templateOptions: {
            label: 'Mjesto rođenja',
            required: true,
            // focus: true
        }
    },
    adresa: {
        key: 'adresa',
        type: 'hInput',
        templateOptions: {
            label: 'Adresa',
            required: true
        }
    }
};

export {fields};



// WEBPACK FOOTER //
// ./app/components/pristanak/form/fields.js